/* eslint-disable max-lines */
/* eslint-disable complexity */
import {
    HeroEllipsisVerticalIcon, NinchatChatsIcon, XIcon,
} from 'components/Icon'
import React, {
    useContext, useEffect,
} from 'react'


import {
    buttonImageWrapper,
    buttonSvgImageWrapper,
    buttonsWrapper, centerButtonWrapper, channelAvatar, defaultHeaderImage,
    dropdown, dropdownItem, dropdownItemButton, dropdownItemIcon, dropdownItemSwitchWrapper, dropdownList,
    embedButton, embedTitle,
    headerContent, headerStyles, imageWrapper, memberImages, moreUsers,
    subtitle as subtitleStyles, svgImageWrapper, title as titleStyles, titleWrapper,
} from './styles'


/* eslint-disable max-len */
import {DropdownOptions} from 'embed/types/dropdown'
import {EmbedContext} from 'components/EmbedContext'
import {EmbedEvent} from 'embed/types/events'
import LetterAvatar from 'components/Avatar/LetterAvatar'
import {RouteName} from 'embed/types/routes'
import Switch from 'components/Switch'
import User from 'components/User'

import {config} from 'embed/listeners'
import {isVideoChannel as isVideoChannelCheck} from 'utils/channels'
import {styled} from 'stitches/config'
import {useChannels} from 'hooks/ninchat'
import {useSendToParent} from 'embed/utils/event'
import {useTranslation} from 'react-i18next'

export const DEFAULT_HEADER_HEIGHT = 60

const StyledEmbedHeader = styled('div', headerStyles)
const StyledHeaderContent = styled('div', headerContent)
const StyledButtonsWrapper = styled('div', buttonsWrapper)
const StyledCenterButtonWrapper = styled('div', centerButtonWrapper)
const StyledEmbedButton = styled('button', embedButton)
const StyledEmbedTitle = styled('button', embedTitle)
const StyledTitleWrapper = styled('div', titleWrapper)
const StyledTitle = styled('div', titleStyles)
const StyledSubtitle = styled('div', subtitleStyles)
const StyledImageWrapper = styled('div', imageWrapper)
const StyledSvgImageWrapper = styled('div', svgImageWrapper)
const StyledDefaultHeaderImage = styled('img', defaultHeaderImage)
const StyledMemberImages = styled('div', memberImages)
const StyledChannelAvatar = styled('div', channelAvatar)
const StyledMoreUsers = styled('div', moreUsers)

const StyledButtonImageWrapper = styled('div', buttonImageWrapper)
const StyledButtonSvgImageWrapper = styled('div', buttonSvgImageWrapper)

const StyledDropdown = styled('div', dropdown)
const StyledDropdownList = styled('ul', dropdownList)
const StyledDropdownItem = styled('li', dropdownItem)
const StyledDropdownItemButton = styled('button', dropdownItemButton)
const StyledDropdownItemIcon = styled('div', dropdownItemIcon)
const StyledDropdownItemSwitchWrapper = styled('div', dropdownItemSwitchWrapper)

type ActionType = 'close' | 'chatList' | 'dropdown';

interface EmbedHeaderProps {
    closeEmbed: () => void
    routeName: string
    channelId: string
}

export const EmbedHeader = (props: EmbedHeaderProps) => {
    const {
        closeEmbed, routeName, channelId: channelIdProp,
    } = props

    const embed = useContext(EmbedContext)
    const {t} = useTranslation()
    const dropdownRef = React.useRef<HTMLDivElement>(null)
    const toggleButtonRef = React.useRef<HTMLButtonElement>(null)

    const [dropdownOpen, setDropdownOpen] = React.useState(false)
    const [dropdownLeft, setDropdownLeft] = React.useState(0)
    const sendToParent = useSendToParent()

    const channelId = channelIdProp || embed?.channelId
    const isChannel = embed?.channelId

    const currentChannel = useChannels([channelId || ''].filter((id) => Boolean(id)))?.[channelId || ''] ?? {}
    const isVideoChannel = isVideoChannelCheck(currentChannel)

    const actions = embed?.containerOptions?.headerOptions?.actions || {}
    const showChatList = embed?.containerOptions?.headerOptions?.actions?.chatList
    const showDropdown = embed?.containerOptions?.headerOptions?.actions?.dropdown
    const showClose = embed?.containerOptions?.headerOptions?.actions?.close

    const iconsToDisplay = 3

    const handleTitleClick = () => {
        if (!embed?.embedState.heroFullVisible && routeName === RouteName.EmbedChannel) {
            embed?.setEmbedState((prevState) => ({
                ...prevState,
                heroFullAbsoluteVisible: !prevState?.heroFullAbsoluteVisible,
            }))
        }
    }

    const renderTitle = () => {
        let title = embed?.containerOptions?.headerOptions?.title || ''
        let subtitle = ''

        let image = embed?.containerOptions?.headerOptions?.image?.svg
            ? <StyledSvgImageWrapper dangerouslySetInnerHTML={{__html: embed?.containerOptions?.headerOptions?.image?.svg}} /> :
            embed?.containerOptions?.headerOptions?.image?.src
                ? <StyledDefaultHeaderImage alt={`${embed?.containerOptions?.headerOptions?.image?.alt || ''}`} src={`${embed?.containerOptions?.headerOptions?.image?.src}`} />
                : ''

        if (routeName === RouteName.EmbedChannel) {
            const channelMembers = embed?.embedState?.channelMembers || []
            const membersToRender = [...channelMembers]

            if (isChannel) {
                title = currentChannel?.channel_attrs?.name || ''
                subtitle = ''
                image = <StyledChannelAvatar><LetterAvatar name={currentChannel?.channel_attrs?.name || ''} /></StyledChannelAvatar>
            } else if (!embed?.embedState.heroFullVisible && !embed?.embedState.heroFullAbsoluteVisible) {
                title = `${membersToRender?.filter((_member, index) => index < iconsToDisplay - 1 || membersToRender.length === iconsToDisplay)
                    .map((member) => embed?.agentName || member?.details?.name + (membersToRender.length > 1 && (embed?.agentJobTitle ?? member?.details?.info?.job_title) ? `(${embed?.agentJobTitle ?? member?.details?.info?.job_title ?? ''})` : ''))
                    .join(', ') || ''}${membersToRender.length > iconsToDisplay ? <span> +{membersToRender.length - iconsToDisplay + 1}</span> : ''}`

                subtitle = membersToRender.length > 1 ? '' : membersToRender?.map((member) => embed?.agentJobTitle ?? member?.details?.info?.job_title).join(', ') || ''

                image = (
                    <StyledMemberImages>
                        {membersToRender?.filter((_member, index) => index < iconsToDisplay - 1 || membersToRender.length === iconsToDisplay).map((member) => (member?.id ? <User avatarIconOverride={embed?.agentAvatar} avatarOnly forceLetterAvatar={!!embed?.agentName} key={member.id} nameOverride={embed?.agentName || ''} userId={member.id} /> : null))}
                        {membersToRender.length > iconsToDisplay ? <StyledMoreUsers>+{membersToRender.length - iconsToDisplay + 1}</StyledMoreUsers> : null}
                    </StyledMemberImages>
                )
            }
        }

        const activeButton = routeName === RouteName.EmbedChannel && !embed?.embedState.heroFullVisible

        return (
            <StyledEmbedTitle {...activeButton ? {activeButton: true} : {tabIndex: -1}} {...!showChatList && !showDropdown ? {noLeftActions: true} : {}} onClick={handleTitleClick}>
                <div>
                    <StyledImageWrapper>
                        {image}
                    </StyledImageWrapper>
                    <StyledTitleWrapper>
                        <StyledTitle data-id='title'>{title || ''}</StyledTitle>
                        <StyledSubtitle data-id='subtitle'>
                            {subtitle || ''}
                        </StyledSubtitle>
                    </StyledTitleWrapper>
                </div>
            </StyledEmbedTitle>
        )
    }

    const renderIcon = (type: ActionType, icon: JSX.Element) => {
        const actionConfig = actions?.[type]
        let image = null

        if (typeof actionConfig?.icon === 'object') {
            if (actionConfig.icon.src) {
                image = <img alt={`${actionConfig.icon.alt || ''}`} height={`${actionConfig.icon.height || ''}`} src={`${actionConfig.icon.src}`} width={`${actionConfig.icon.width || ''}`} />
            } else if (actionConfig.icon.svg) {
                image = (
                    <StyledButtonSvgImageWrapper
                        css={{
                            $$height: `${actionConfig.icon.height || ''}px`,
                            $$width: `${actionConfig.icon.width || ''}px`,
                        }}
                        dangerouslySetInnerHTML={{__html: actionConfig.icon.svg}}
                    />)
            } else {
                image = (
                    <StyledButtonSvgImageWrapper css={{
                        $$height: `${actionConfig.icon.height || ''}px`,
                        $$width: `${actionConfig.icon.width || ''}px`,
                    }}
                    >{icon}
                    </StyledButtonSvgImageWrapper>)
            }
        } else if (actionConfig?.icon === true) {
            image = icon
        }

        if (image === null) {
            return null
        }

        return <StyledButtonImageWrapper>{image}</StyledButtonImageWrapper>
    }

    const toggleDropdown = (ev: React.MouseEvent<HTMLButtonElement>) => {
        const {offsetLeft: left} = ev.currentTarget
        setDropdownLeft(left - 10)
        setDropdownOpen((prevState) => !prevState)
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const toggleChatList = () => {}

    const changeMute = () => {
        const newMuteState = !embed?.embedState?.mute

        embed?.setEmbedState((prevState) => ({
            ...prevState,
            mute: newMuteState,
        }))

        sendToParent({
            event: EmbedEvent.EmbedSound,
            mute: newMuteState,
            targetOrigin: config.get('targetOrigin') || '',
        })
    }

    // Custom dropdown items run a host-page onSelect handler, which lives outside the iframe, so notify the parent by name
    const handleCustomAction = (name: string, closeDropdownAfterSelect?: boolean) => {
        if (closeDropdownAfterSelect) {
            setDropdownOpen(false)
        }

        sendToParent({
            event: EmbedEvent.EmbedDropdownAction,
            name,
            targetOrigin: config.get('targetOrigin') || '',
        })
    }

    const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as HTMLElement
        const isClickInside = dropdownRef.current?.contains(target) || toggleButtonRef.current?.contains(target)

        if (!isClickInside && dropdownOpen) {
            setDropdownOpen(false)
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true)
        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    }, [dropdownOpen])

    const renderCloseIcon = () => renderIcon('close', <XIcon />)
    const renderChatsIcon = () => renderIcon('chatList', <NinchatChatsIcon />)
    const renderDropdownIcon = () => renderIcon('dropdown', <HeroEllipsisVerticalIcon size={24} />)

    const isEmbedHeroVisible = embed?.embedState?.heroFullVisible || embed?.embedState?.heroFullAbsoluteVisible || isVideoChannel
    const isMuted = embed?.embedState?.mute

    const hasAllowedDropdownOptions = (embed?.containerOptions?.headerOptions?.dropdownOptions || []).length > 0

    return (
        <StyledEmbedHeader
            css={
                {
                    $$headerHeight: `${embed?.containerOptions?.headerOptions?.height || DEFAULT_HEADER_HEIGHT}px`,
                    $$imageHeight: embed?.containerOptions?.headerOptions?.image?.height ? `${embed?.containerOptions?.headerOptions?.image?.height}px` : 'auto',
                    $$imageWidth: embed?.containerOptions?.headerOptions?.image?.width ? `${embed?.containerOptions?.headerOptions?.image?.width}px` : 'auto',
                }
            }
            isEmbedHeroVisible={isEmbedHeroVisible}
        >
            <StyledHeaderContent>
                <StyledButtonsWrapper>
                    {showChatList ?
                        <StyledEmbedButton
                            aria-label={embed?.containerOptions?.headerOptions?.actions?.chatList?.buttonTitle}
                            title={embed?.containerOptions?.headerOptions?.actions?.chatList?.buttonTitle}
                            type='button'
                            variant='chatList'
                        >{renderChatsIcon()}<span className='text'>{actions?.chatList?.text || ''}</span>
                        </StyledEmbedButton>
                        : ''}
                    {showDropdown ?
                        <StyledEmbedButton
                            aria-label={embed?.containerOptions?.headerOptions?.actions?.dropdown?.buttonTitle}
                            onClick={toggleDropdown}
                            ref={toggleButtonRef}
                            title={embed?.containerOptions?.headerOptions?.actions?.dropdown?.buttonTitle}
                            type='button'
                            variant='dropdown'
                        >{renderDropdownIcon()} <span>{actions?.dropdown?.text || ''}</span>
                        </StyledEmbedButton>
                        : ''}
                    {dropdownOpen && hasAllowedDropdownOptions
                        ? (
                            <StyledDropdown css={{$$left: `${dropdownLeft}px`}} ref={dropdownRef}>
                                <StyledDropdownList>
                                    {(embed?.containerOptions?.headerOptions?.dropdownOptions || []).map((option) => {
                                        if (option.name === DropdownOptions.Mute) {
                                            return (
                                                <StyledDropdownItem key={option.name}>
                                                    <StyledDropdownItemButton
                                                        name={option.name}
                                                        onClick={changeMute}
                                                    >
                                                        <span>{t('Sounds')}</span>
                                                        <StyledDropdownItemSwitchWrapper>
                                                            <Switch hideStateLabel={true} horizontal={true} id='mute-switch' on={!isMuted} />
                                                        </StyledDropdownItemSwitchWrapper>
                                                    </StyledDropdownItemButton>
                                                </StyledDropdownItem>
                                            )
                                        } else if (option.name === DropdownOptions.Close) {
                                            return (
                                                <StyledDropdownItem key={option.name}>
                                                    <StyledDropdownItemButton
                                                        onClick={closeEmbed}
                                                    >
                                                        <StyledDropdownItemIcon name={option.name}>
                                                            <XIcon />
                                                        </StyledDropdownItemIcon>
                                                        <span>{t('Close chat')}</span>
                                                    </StyledDropdownItemButton>
                                                </StyledDropdownItem>
                                            )
                                        } else if (option.name === DropdownOptions.ChatList) {
                                            return (
                                                <StyledDropdownItem key={option.name}>
                                                    <StyledDropdownItemButton
                                                        onClick={toggleChatList}
                                                    >
                                                        <StyledDropdownItemIcon name={option.name}>
                                                            <NinchatChatsIcon />
                                                        </StyledDropdownItemIcon>
                                                        <span>{t('Chat list')}</span>
                                                    </StyledDropdownItemButton>
                                                </StyledDropdownItem>
                                            )
                                        }
                                        return (
                                            <StyledDropdownItem key={option.name}>
                                                <StyledDropdownItemButton onClick={() => handleCustomAction(option.name, 'closeDropdownAfterSelect' in option ? option.closeDropdownAfterSelect : false)}>
                                                    {'icon' in option && option.icon ?
                                                        <StyledDropdownItemIcon {...(option.icon.svg ? {dangerouslySetInnerHTML: {__html: option.icon.svg}} : undefined)}>
                                                            { option.icon.src ? <img alt={option.icon.alt} height={option.icon.height} src={option.icon.src} width={option.icon.width} /> : null}
                                                        </StyledDropdownItemIcon>
                                                        : null}
                                                    <span>{'label' in option ? option.label : null}</span>
                                                </StyledDropdownItemButton>
                                            </StyledDropdownItem>
                                        )

                                        return null
                                    })}
                                </StyledDropdownList>
                            </StyledDropdown>
                        )
                        : null}
                </StyledButtonsWrapper>
                <StyledButtonsWrapper variant='center'>
                    <StyledCenterButtonWrapper {...!showChatList && !showDropdown ? {noLeftActions: true} : {}}>{renderTitle()}</StyledCenterButtonWrapper>
                </StyledButtonsWrapper>
                <StyledButtonsWrapper>
                    {showClose ?
                        <StyledEmbedButton aria-label={embed?.containerOptions?.headerOptions?.actions?.close?.buttonTitle} onClick={() => closeEmbed()} textLeft={true} title={embed?.containerOptions?.headerOptions?.actions?.close?.buttonTitle} type='button' variant='close'>
                            <span className='text'>{actions?.close?.text || ''}</span>{renderCloseIcon()}
                        </StyledEmbedButton>
                        : ''}
                </StyledButtonsWrapper>
            </StyledHeaderContent>
        </StyledEmbedHeader>
    )
}
